import { useTranslation } from 'react-i18next';

import { CommentContextData } from '../../../db/comments/types';
import { i18nNS } from '../../../i18n';
import { Tab, Tabs } from './styles';
import useCommentsTabsVM, { UseCommentsTabs } from './vm';

export interface CommentsTabsProps extends UseCommentsTabs {}

const CommentsTabs = ({ ...vmProps }: CommentsTabsProps) => {
  const { t } = useTranslation([i18nNS.COMMENTS]);

  const { tabs, activeTab, handleTabChange: _handleTabChange } = useCommentsTabsVM(vmProps);

  const handleTabChange = (newContext: CommentContextData) => () => {
    _handleTabChange(newContext);
  };

  if (!tabs) return null;

  return (
    <Tabs
      variant="fullWidth"
      value={activeTab?.context.subType || ''}
      aria-label={t('discussion_types', { ns: i18nNS.COMMENTS })}
    >
      {tabs.map((tab) => (
        <Tab
          id={tab.id}
          aria-controls={tab['aria-controls']}
          key={tab.context.subType}
          label={tab.title}
          value={tab.context.subType}
          onClick={handleTabChange(tab.context)}
          disabled={tab.isDisabled}
        />
      ))}
    </Tabs>
  );
};

export default CommentsTabs;
